<template>
  <b-navbar>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img src="../assets/srvu-logo.png">
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item v-if="token" tag="router-link" :to="{ path: '/integrations' }">
        Integrations
      </b-navbar-item>
      <!-- <b-navbar-item v-if="token" tag="router-link" :to="{ path: '/workflows' }">
        Workflows
      </b-navbar-item> -->
      <!-- <b-navbar-item v-if="token" tag="router-link" :to="{ path: '/events' }">
        Event Stream
      </b-navbar-item> -->
    </template>

    <template slot="end">
      <b-navbar-item v-if="!token" tag="div">
        <div class="buttons" @click="$emit('login')">
          <a class="button is-light">
            Login
          </a>
        </div>
      </b-navbar-item>
      <b-navbar-item v-else tag="div">
        <div class="buttons" @click="logout">
          <a class="button is-dark">
            Logout
          </a>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>

</template>

<style>
  .router-link-exact-active { font-weight:bold; }
</style>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Navigation',
  computed: {
    ...mapGetters(['token']),
  },
  methods: {
    ...mapActions(['setToken']),
    logout() {
      this.setToken('');
      this.$router.push('Home');
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue